import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';

const SchoolManager = ({ tenantId }) => {
  const [schools, setSchools] = useState([]);
  const [newSchool, setNewSchool] = useState('');
  const [loading, setLoading] = useState(true);

  // Fetch existing schools
  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const docRef = doc(db, 'districts', tenantId, 'settings', 'schools');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data().schoolList) {
          setSchools(docSnap.data().schoolList);
        }
      } catch (error) {
        console.error("Error fetching schools:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSchools();
  }, [tenantId]);

  // Add a new school
  const handleAddSchool = async (e) => {
    e.preventDefault();
    if (!newSchool.trim()) return;

    const updatedSchools = [...schools, newSchool.trim()].sort();
    
    try {
      await setDoc(doc(db, 'districts', tenantId, 'settings', 'schools'), {
        schoolList: updatedSchools
      }, { merge: true });
      
      setSchools(updatedSchools);
      setNewSchool('');
    } catch (error) {
      console.error("Error saving school:", error);
    }
  };

  // Remove a school
  const handleRemoveSchool = async (schoolToRemove) => {
    if (!window.confirm(`Are you sure you want to remove ${schoolToRemove}?`)) return;
    
    const updatedSchools = schools.filter(s => s !== schoolToRemove);
    try {
      await setDoc(doc(db, 'districts', tenantId, 'settings', 'schools'), {
        schoolList: updatedSchools
      }, { merge: true });
      setSchools(updatedSchools);
    } catch (error) {
      console.error("Error removing school:", error);
    }
  };

  if (loading) return <div>Loading district infrastructure...</div>;

  return (
    <div style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', border: '1px solid #ddd' }}>
      <h3 style={{ margin: '0 0 15px 0', color: '#003366', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span>🏫</span> District Schools
      </h3>
      <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
        Manage the master list of buildings for student and staff assignments.
      </p>

      <form onSubmit={handleAddSchool} style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <input
          type="text"
          value={newSchool}
          onChange={(e) => setNewSchool(e.target.value)}
          placeholder="e.g., Taylor County High School"
          style={{ flex: 1, padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          required
        />
        <button type="submit" style={{ backgroundColor: '#003366', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}>
          Add Building
        </button>
      </form>

      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {schools.map((school, index) => (
          <li key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', borderBottom: '1px solid #eee', backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
            <span>{school}</span>
            <button onClick={() => handleRemoveSchool(school)} style={{ color: '#ba0c2f', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>
              Remove
            </button>
          </li>
        ))}
        {schools.length === 0 && <li style={{ color: '#999', fontStyle: 'italic' }}>No schools added yet.</li>}
      </ul>
    </div>
  );
};

export default SchoolManager;